<template>
	<li v-if="channel && users" class="sub-menu-item no-bg-on-hover" role="tab">
		<div class="sub-menu-item-header">Currently online</div>

		<div class="sub-menu-item-content">
			<hr class="m-b-5" />

			<span v-if="users.length === 0">
				<p class="sub-menu-item-title m-t-20">There are no team members currently online right now.</p>
			</span>

			<div v-for="user in users" class="version flex flex-justify-between p-t-5 p-h-0" :key="user.id">
				<span class="sub-menu-item-title m-b-0" style="line-height: 24px"><img :src="user.photo_url" class="spark-nav-profile-photo m-r-10" />{{ user.name }}</span>
			</div>
		</div>
	</li>
</template>

<script>
export default {
	props: ['channel', 'users'],

	mounted() {
		console.log('online-team-members channel: ', this.channel)
		console.log('online-team-members users: ', this.users)
	}
}
</script>
